import React from 'react';

import { ChartDetail } from '../../components/ChartDetail/ChartDetail';
import { ChartHeaderLayout } from '../../layouts/ChartHeaderLayout/ChartHeaderLayout';


const ChartDetailPage = () => {
    return <ChartHeaderLayout chart="true" chartDetail={true} chartProject={true}>
        <ChartDetail/>
    </ChartHeaderLayout>
}

export default ChartDetailPage;